export { default } from './local-storage';
